import PropTypes from 'prop-types'
/**
 * @param {string} className - classes that you want to put on the button.
 * @param {integer} width - width of the Educaplay logo.
 * @param {integer} height - height of the Educaplay logo.
 * @returns {React.ReactNode} - return Educaplay Logo. 
 */
export function EducaplayLogo(props) {
    const { className, width = 640, height = 587 } = props;

    return (
        <svg
            className={className}
            width={width}
            height={height}
            fill="none"
            viewBox="0 0 640 587"
        >
            <path
                fill="#6EB118"
                d="M532.321 31.927L158.862.094C64.915-3.012-6.516 71.524.472 165.472l5.435 46.585L40.07 473.711c4.658 64.443 61.337 115.687 125.78 112.582l306.687-24.069c65.219-3.106 121.898-57.456 127.333-122.675l39.598-286.5c6.211-64.443-42.703-118.793-107.147-121.122z"
            ></path>
            <path
                fill="#fff"
                fillRule="evenodd"
                d="M228.954 334.488h184.328c1.488 0 3.152.015 4.916.031 5.241.049 11.355.106 16.303-.21 6.399-.409 18.163-1.625 28.401-9.406 12.105-9.2 15.908-22.391 16.463-33.412.514-10.176-1.483-21.488-4.384-33.127-5.514-22.12-20.625-50.585-44.946-73.768-24.903-23.738-60.536-42.883-106.413-42.883-74.216 0-158.626 53.14-158.626 158.321 0 102.292 84.629 156.13 158.626 156.13 49.234 0 84.844-23.057 103.208-38.711 12.237-10.432 13.701-28.809 3.269-41.046-10.431-12.238-28.808-13.702-41.046-3.27-12.303 10.488-34.967 24.796-65.431 24.796-39.727 0-80.055-22.42-94.668-63.445zm94.668-134.543c-43.172 0-87.393 25.89-98.004 76.311h187.664a620.33 620.33 0 016.11.035 174.413 174.413 0 00-.914-3.843c-2.759-11.071-12.039-29.895-28.622-45.702-16-15.252-37.785-26.801-66.234-26.801z"
                clipRule="evenodd"
            ></path>
        </svg>
    );
}

EducaplayLogo.propTypes = {
    className: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number
}
